import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as DealsIcon } from "../../Global Icons/Deals.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCategoryList,
  viewSubCategoryList,
} from "../../Redux/Actions/categoryActions";
import {
  viewCityListPagination,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import {
  editProject,
  getProjectData,
} from "../../Redux/Actions/projectActions";
import MapsAddress from "../../Global Functions/mapsAddress";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import AddImage from "../../Global Functions/addImage";
import MultipleImagesShowerModalGlobal from "../../Global Functions/multipleImagesShowerModalGlobal";
import AddProjectAmenities from "../../Global Functions/AddProjectAmenities";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesActions";
import AroundThisProject from "../../Global Functions/AroundThisProject";
import { getEnums } from "../../Redux/Actions/enumsActions";
import BrandsNearbyDropdown from "../../Commercial/Commercial Functions/Brands/brandsNearby";

const EditProject = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [categoryArray, setCategoryArray] = useState([]);
  const [projectPayload, setProjectPayload] = useState({
    project_id: id,
    added_by: "admin",
    project_name: "",
    brand_name: "",
    construction_status: "",
    builder_id: "",
    rera_id: "",
    project_type: "",
    categories: [],
    launch_date: "",
    lat: "",
    starting_price: "",
    lng: "",
    quantity: "",
    brands_nearby: [
      {
        name: "",
        image_url: "",
      },
    ],
    city: "",
    project_area: "",
    area_unit: "",
    state: "",
    country: "",
    possesion_date: "",
    booking_start_date: "",
    street_address: "",
    about_project: "",
    about_builder: "",
    around_this_project: [
      {
        icon: "",
        name: "",
        type: "",
        location: {
          type: "Point",
          coordinates: [null, null],
        },
        distance: null,
      },
    ],
    amenities: [],
    cover_photo: "",
    images: [],
  });

  const [aroundThisList, setAroundThisList] = useState([]);

  const handlerNavigation = () => {
    navigate("/enquiry");
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setProjectPayload((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddImages = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      const newImage = {
        url: responseUrl,
        index: projectPayload.images.length + 1,
      };
      setProjectPayload((prevData) => ({
        ...prevData,
        images: [...prevData.images, newImage],
      }));
    }
  };

  const categoryAdditionHandler = (event) => {
    const selectedId = event.target.value;
    if (!selectedId) return;
    const selectedCategory = subCategories?.data.find(
      (cat) => String(cat._id) === String(selectedId)
    );

    if (!selectedCategory) {
      toast.error("Category not found!");
      return;
    }

    const alreadyExists = (projectPayload.categories || []).some(
      (cat) => cat._id === selectedCategory._id
    );
    if (alreadyExists) {
      toast.error("Category already exists!");
      return;
    }

    const categoryObj = {
      _id: selectedCategory._id,
      name: selectedCategory.name,
    };

    const updatedCategories = [...categoryArray, categoryObj];

    setCategoryArray(updatedCategories);

    setProjectPayload((prevData) => ({
      ...prevData,
      categories: [
        ...(prevData.categories || []),
        {
          _id: selectedCategory._id,
          name: selectedCategory.name,
        },
      ],
    }));
  };

  const handleAddressChange = ({ address, lat, lng }) => {
    setProjectPayload((prev) => ({
      ...prev,
      street_address: address,
      lat,
      lng,
    }));
  };

  const handleSubAmenitiesChange = (newAmenities) => {
    setProjectPayload((prev) => {
      const existing = prev.amenities || [];

      const merged = [
        ...existing,
        ...newAmenities.filter(
          (newItem) => !existing.some((e) => e._id === newItem._id)
        ),
      ];

      return {
        ...prev,
        amenities: merged,
      };
    });
  };

  const handleSubmit = async (event) => {
    try {
      const patchedPayload = {
        ...projectPayload,
        area_unit:
          projectPayload.project_area > 0 && !projectPayload.area_unit
            ? "acre"
            : projectPayload.area_unit,
      };

      const updatedAroundThisProject = (
        patchedPayload.around_this_project || []
      ).map((item) => {
        const coords = item.location?.coordinates;

        if (
          Array.isArray(coords) &&
          coords.length === 2 &&
          coords[0] > 50 &&
          coords[1] < 50
        ) {
          return {
            ...item,
            location: {
              ...item.location,
              coordinates: [coords[1], coords[0]],
            },
          };
        }
        return item;
      });

      patchedPayload.around_this_project = updatedAroundThisProject;
      const isEmptyValue = (value) => {
        if (
          value === "" ||
          value === undefined ||
          value === null ||
          (typeof value === "number" && isNaN(value))
        )
          return true;

        if (Array.isArray(value)) {
          return (
            value.length === 0 ||
            value.every(
              (item) =>
                typeof item === "object" &&
                item !== null &&
                Object.values(item).every(
                  (val) => val === "" || val === null || val === undefined
                )
            )
          );
        }

        return false;
      };

      const filteredPayload = Object.fromEntries(
        Object.entries(patchedPayload).filter(
          ([_, value]) => !isEmptyValue(value)
        )
      );
      const response = await dispatch(editProject(filteredPayload));
      response.statusCode === 200
        ? navigate("/enquiry")
        : console.error(response?.message);
    } catch (error) {
      console.error(error?.message);
    }
  };

  useEffect(() => {
    setProjectPayload((prev) => ({
      ...prev,
      around_this_project: aroundThisList,
    }));
  }, [aroundThisList]);

  const handleCoverImage = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);

    if (responseUrl) {
      setProjectPayload((prevData) => ({
        ...prevData,
        cover_photo: responseUrl,
      }));
    }
  };

  useEffect(() => {
    dispatch(getEnums());
    dispatch(getProjectData(id));
    const payload = {
      amenities_for: "project",
      page: 1,
      limit: 2000,
    };
    dispatch(viewAmenitiesList(payload));
    dispatch(viewCategoryList(payload));
  }, [dispatch, id]);

  useEffect(() => {
    if (projectPayload.project_type) {
      const payload = {
        page: 1,
        limit: 2000,
        category_id: projectPayload.project_type,
      };
      dispatch(viewSubCategoryList(payload));
    }
  }, [dispatch, projectPayload.project_type]);

  useEffect(() => {
    dispatch(viewCountryListPagination());
    if (projectPayload.country) {
      dispatch(viewStateListPagination({ country: projectPayload.country }));
    }
    if (projectPayload.state) {
      dispatch(
        viewCityListPagination({
          state: projectPayload.state,
          country: projectPayload.country,
        })
      );
    }
  }, [dispatch, projectPayload.country, projectPayload.state]);

  const { categories, subCategories } = useSelector(
    (state) => state.categories || {}
  );
  const { project } = useSelector((state) => state.projects || {});
  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { amenities } = useSelector((state) => state.amenities || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});

  useEffect(() => {
    if (project?.data) {
      setProjectPayload((prev) => ({
        ...prev,
        ...project.data,
        state: project?.data?.state?._id,
      }));
    }
    if (projectPayload.country) {
      dispatch(
        viewStateListPagination({ country: projectPayload?.country?._id })
      );
    }
    if (projectPayload.state) {
      dispatch(viewCityListPagination({ state: projectPayload?.state }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.data?._id]);

  const projectAmenities = Array.isArray(amenities?.data)
    ? amenities.data.filter(
        (amenity) =>
          amenity.project_type._id === projectPayload.project_type._id &&
          amenity.amenities_for === "project"
      )
    : [];

  useEffect(() => {
    if (
      project?.data?.location?.coordinates &&
      project?.data?.location?.coordinates.length > 0
    ) {
      setProjectPayload((prevData) => ({
        ...prevData,
        // this is reversed - from backend we get lat first long second but while adding it is long first and lat second

        lat: project?.data?.location?.coordinates[1],
        lng: project?.data?.location?.coordinates[0],
      }));
    }
  }, [project?.data?.location?.coordinates]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRemoveAmenity = (amenityToRemove) => {
    const updatedAmenities = projectPayload.amenities.filter(
      (amenity) => amenity._id !== amenityToRemove._id
    );

    setProjectPayload((prev) => ({
      ...prev,
      amenities: updatedAmenities,
    }));
  };

  const handleRemove = (idToRemove) => {
    const updated = projectPayload.categories.filter(
      (cat) => cat._id !== idToRemove
    );
    setCategoryArray(updated);
    setProjectPayload((prev) => ({ ...prev, categories: updated }));
  };
  const handleAroundChange = useCallback((data) => {
    setProjectPayload((prev) => ({
      ...prev,
      around_this_project: data,
    }));
  }, []);

  const handleBrandsAddition = (brands) => {
    setProjectPayload((prevData) => ({
      ...prevData,
      brands_nearby: brands,
    }));
  };

  console.log(projectPayload.state);

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10">
        <InnerHeading
          Icon={DealsIcon}
          onClick={() => handlerNavigation()}
          heading="Edit Project"
          buttonLabel="View Projects"
        ></InnerHeading>
        <TextInput
          required
          value={projectPayload.brand_name}
          label="Brand Name"
          placeholder="Enter Name"
          name="brand_name"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <div className="flex-container flex-column">
          <TextInput
            forImage={true}
            htmlFor="builder_logo"
            onChange={async (event) => {
              const uploadedFile = event.target.files[0];
              if (!uploadedFile) return;
              const responseUrl = await AddImage(uploadedFile);
              if (responseUrl) {
                setProjectPayload((prevData) => ({
                  ...prevData,
                  builder_logo: responseUrl,
                }));
              }
            }}
            span="Brand Logo"
            disabled={projectPayload.builder_logo ? true : false}
            type="file"
            label="Click to Upload Image"
            id="builder_logo"
            name="builder_logo"
          ></TextInput>
          <ImageShowerModalGlobal
            state={projectPayload}
            setState={setProjectPayload}
            keyField="builder_logo"
            file={projectPayload.builder_logo}
          ></ImageShowerModalGlobal>
        </div>
        <TextInput
          required
          value={projectPayload.project_name}
          name="project_name"
          placeholder="Enter Name"
          label="Project Name"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          value={projectPayload.rera_id}
          required
          label="RERA-ID"
          placeholder="Enter RERA ID"
          name="rera_id"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <SelectInput
          required
          placeholder="Select an Option"
          options={
            Array.isArray(categories?.data)
              ? categories.data.map((category) => ({
                  label: category.name,
                  value: category._id,
                }))
              : []
          }
          name="project_type"
          value={projectPayload.project_type}
          label="Project Type"
          onChange={handleAddChange}
        ></SelectInput>

        <div>
          <SelectInput
            placeholder="Select an Option"
            required
            disabled={projectPayload.project_type ? false : true}
            name="categories"
            options={
              Array.isArray(subCategories?.data)
                ? subCategories.data.map((category) => ({
                    label: category.name,
                    value: category._id,
                  }))
                : []
            }
            label="Category"
            onChange={(event) => {
              categoryAdditionHandler(event);
            }}
          ></SelectInput>
          <div className="flex-container gap-10 margin-h-10 flex-wrap">
            {projectPayload.categories.map((catId) => {
              return (
                <p
                  key={catId.index}
                  className="margin-0 border-1-grey padding-5"
                >
                  {catId.name || "Unknown"}
                  <span
                    onClick={() => handleRemove(catId._id)}
                    style={{ color: "red", cursor: "pointer" }}
                  >
                    ❌
                  </span>
                </p>
              );
            })}
          </div>
        </div>

        <TextInput
          label="Project Area"
          required
          placeholder="Enter Area"
          name="project_area"
          value={projectPayload.project_area}
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <SelectInput
          label="Area in(Sq.ft/Acre)"
          value={projectPayload.area_unit}
          placeholder="acre"
          disabled={projectPayload.project_area === "" ? true : false}
          name="area_unit"
          type="number"
          onChange={handleAddChange}
          options={
            enumsData?.data?.AreaUnit
              ? Object.values(enumsData.data.AreaUnit).map((item) => ({
                  label: item,
                  value: item,
                }))
              : []
          }
        ></SelectInput>
        <TextInput
          label="Starting Price"
          name="starting_price"
          placeholder="Enter Price"
          type="number"
          required
          min={0}
          onBlur={(event) => {
            const value = event.target.value;

            if (!value) {
              toast.error("Starting Price cannot be empty or invalid");
            }
          }}
          value={projectPayload.starting_price}
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Launch Date"
          name="launch_date"
          type="date"
          value={
            projectPayload.launch_date
              ? new Date(projectPayload.launch_date).toISOString().split("T")[0]
              : ""
          }
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Possession Date"
          disabled={projectPayload.launch_date ? false : true}
          name="possesion_date"
          type="date"
          value={
            projectPayload.possesion_date
              ? new Date(projectPayload.possesion_date)
                  .toISOString()
                  .split("T")[0]
              : ""
          }
          min={projectPayload.launch_date}
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Booking Start Date"
          value={
            projectPayload.booking_start_date
              ? new Date(projectPayload.booking_start_date)
                  .toISOString()
                  .split("T")[0]
              : ""
          }
          name="booking_start_date"
          type="date"
          onChange={handleAddChange}
        ></TextInput>
        <SelectInput
          required
          name="country"
          value={projectPayload.country}
          placeholder="Select An Option"
          label="Country"
          options={
            Array.isArray(countryList?.data)
              ? countryList.data.map((category) => ({
                  label: category.country_name,
                  value: category._id,
                }))
              : []
          }
          onChange={handleAddChange}
        ></SelectInput>
        <SelectInput
          disabled={projectPayload.country ? false : true}
          required
          value={projectPayload?.state}
          placeholder="Select An Option"
          options={
            Array.isArray(states?.data)
              ? states.data.map((category) => ({
                  label: category.state_name,
                  value: category._id,
                }))
              : []
          }
          name="state"
          label="State"
          onChange={handleAddChange}
        ></SelectInput>
        <SelectInput
          required
          value={projectPayload.city || ""}
          placeholder="Select An Option"
          disabled={projectPayload.state ? false : true}
          options={
            Array.isArray(cities?.data)
              ? cities.data.map((category) => ({
                  label: category.city_name,
                  value: category._id,
                }))
              : []
          }
          name="city"
          label="City"
          onChange={handleAddChange}
        ></SelectInput>
        {categories?.data ? (
          categories?.data?.find((category) => category.name === "Commercial")
            ._id === projectPayload.project_type ? (
            <div>
              <TextInput
                required
                label="Units in Project"
                
                onChange={handleAddChange}
                placeholder="Enter Units"
                type="number"
                min={0}
                name="quantity"
              ></TextInput>
              <div className="margin-h-10">
                <BrandsNearbyDropdown
                  onChange={handleBrandsAddition}
                ></BrandsNearbyDropdown>
              </div>
            </div>
          ) : null
        ) : (
          []
        )}

        <div
          disabled={projectPayload.city ? false : true}
          className="grid-span-2"
        >
          <MapsAddress
            disabled={projectPayload.city ? false : true}
            value={{
              address: projectPayload.street_address,
              lat: projectPayload.lat,
              lng: projectPayload.lng,
            }}
            onChange={handleAddressChange}
          ></MapsAddress>
        </div>
        <div className="grid-span-2">
          <AddProjectAmenities
            disabled={projectPayload.project_type ? false : true}
            onChange={handleSubAmenitiesChange}
            defaultProjectType={projectPayload.project_type._id}
            amenities={projectAmenities}
            selectedSubAmenityIds={projectPayload.amenities}
          ></AddProjectAmenities>
          <div
            style={{ flexWrap: "wrap" }}
            className="flex-container gap-10 border-1-grey padding-5 border-15"
          >
            Amenities to be Submitted :
            {Array.isArray(projectPayload.amenities)
              ? projectPayload.amenities.map((amenity, index) => (
                  <div className="flex-container gap-10 align-center padding-5 border-1-grey flex-container border-15">
                    <p className="margin-0">{amenity.name}</p>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRemoveAmenity(amenity)}
                    >
                      ❌
                    </span>
                  </div>
                ))
              : null}
          </div>
        </div>
        <div className="border-1-grey padding-10 border-24">
          <AroundThisProject
            aroundThisList={aroundThisList}
            setAroundThisList={setAroundThisList}
            existingAround={projectPayload?.around_this_project}
            onChange={handleAroundChange}
          ></AroundThisProject>
        </div>
        <SelectInput
          name="construction_status"
          onChange={handleAddChange}
          label="Select Construction Status"
          value={projectPayload.construction_status}
          placeholder="Select an Option"
          options={
            enumsData?.data?.ConstructionStatus
              ? Object.values(enumsData.data.ConstructionStatus).map(
                  (item) => ({ label: item, value: item })
                )
              : []
          }
        ></SelectInput>
        <div className="grid-span-2">
          <TextInput
            required
            name="about_project"
            label="About Project"
            placeholder="Enter Details"
            value={projectPayload.about_project}
            type="text"
            onChange={handleAddChange}
          ></TextInput>
          <TextInput
            name="about_builder"
            placeholder="Enter Details"
            label="About Builder"
            value={projectPayload.about_builder}
            type="text"
            onChange={handleAddChange}
          ></TextInput>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="cover_photo"
            span="Cover Image(Maximum 1)"
            required
            onChange={(event) => handleCoverImage(event)}
            type="file"
            label="Click to Upload Image"
            id="cover_photo"
            name="cover_photo"
            disabled={projectPayload.cover_photo ? true : false}
          ></TextInput>
          <ImageShowerModalGlobal
            state={projectPayload}
            setState={setProjectPayload}
            keyField="cover_photo"
            file={projectPayload.cover_photo}
          ></ImageShowerModalGlobal>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="images"
            onChange={(event) => handleAddImages(event)}
            type="file"
            span="Project Images"
            required
            label="Click to Upload Image"
            id="images"
            name="images"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.images}
            setState={setProjectPayload}
            fieldName="images"
          ></MultipleImagesShowerModalGlobal>
        </div>
        <div className="grid-span-2 flex-end">
          <Link to="/enquiry">
            <button
              // onClick={() => (window.location.hrf = "/enquiry")}
              className="button-class-white"
            >
              Cancel
            </button>
          </Link>
          <button className="button-class" onClick={() => handleSubmit()}>
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditProject;
